module.exports = __webpack_public_path__ + "static/img/Boosted Brown.dccf8d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/Boosted Brown.jpg
// module id = HMs/
// module chunks = 12